import React from "react";
import { createRoot } from "react-dom/client";
import "./App.css";
import MarktingPage from "./marketing-page/MarketingPage";

createRoot(document.getElementById("root")).render(<MarktingPage />);
